var TERMS;
(function (TERMS) {
    TERMS["seconds"] = "seconds";
    TERMS["minutes"] = "minutes";
    TERMS["hours"] = "hours";
    TERMS["days"] = "days";
    TERMS["months"] = "months";
    TERMS["years"] = "years";
})(TERMS || (TERMS = {}));

export { TERMS };
//# sourceMappingURL=terms.js.map
